import { Popconfirm } from 'antd';
import i18next from 'i18next';
import React from 'react';
import { FaEye, FaPencilAlt, FaRegTrashAlt } from 'react-icons/fa';
import Button from '~/components/Button';
import Can from '~/components/Can';
import Strong from '~/components/Strong';
import { TableActions } from '~/components/Table';

export const stockWriteOffsColumns = (handleDelete, handleEdit, isMobile) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (_, record) => (
          <div>
            <Strong>{i18next.t('screens:stockWriteOffs.code')}:</Strong> {record?.id}
            <br />
            <Strong>{i18next.t('screens:default.createdBy')}:</Strong> {record?.user_id?.name}
            <br />
            <Strong>{i18next.t('screens:default.createdAt')}:</Strong>{' '}
            {new Date(record?.created_at).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })}
            <br />
            <Strong>{i18next.t('screens:stockWriteOffs.withoutCost')}:</Strong> {record?.without_cost ? 'Sim' : 'Não'}
            <br />
            <Strong>{i18next.t('screens:stockWriteOffs.justification')}:</Strong>{' '}
            {record?.justification ? record.justification : 'Sem justificativa'}
            <br />
            <TableActions align="center" justify="center" isMobile={isMobile}>
              <Button size="small" title="Visualizar" onClick={() => handleEdit(record, true)}>
                <FaEye />
              </Button>
              <Can permission="@lowStock/edit">
                <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
                  <FaPencilAlt />
                </Button>
              </Can>
              <Can permission="@lowStock/delete">
                <Popconfirm
                  title={i18next.t('messages:confirmDelete')}
                  okText={i18next.t('messages:yes')}
                  onConfirm={() => handleDelete(record.id)}
                  cancelText={i18next.t('messages:no')}
                >
                  <Button size="small" title="Excluir">
                    <FaRegTrashAlt />
                  </Button>
                </Popconfirm>
              </Can>
            </TableActions>
          </div>
        ),
      },
    ];
  }

  return [
    {
      title: i18next.t('screens:stockWriteOffs.code'),
      dataIndex: 'id',
      key: 'id',
      width: '18%',
      render: (_, record) => record.id,
    },
    {
      title: i18next.t('screens:default.createdBy'),
      dataIndex: 'name',
      key: 'name',
      width: '18%',
      render: (_, record) => record.user_id.name,
    },
    {
      title: i18next.t('screens:default.createdAt'),
      dataIndex: 'created_at',
      key: 'created_at',
      width: '18%',
      render: (_, record) => {
        const date = new Date(record.created_at);
        return date.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
      },
    },
    {
      title: i18next.t('screens:stockWriteOffs.withoutCost'),
      dataIndex: 'without_cost',
      key: 'without_cost',
      width: '18%',
      render: (_, record) => {
        return record.without_cost ? 'Sim' : 'Não';
      },
    },
    {
      title: i18next.t('screens:stockWriteOffs.justification'),
      dataIndex: 'justification',
      key: 'justification',
      width: '18%',
      render: (_, record) => (record.justification ? record.justification : 'Sem justificativa'),
    },
    {
      title: i18next.t('screens:default.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '70px',
      align: 'center',
      render: (_, record) => (
        <TableActions align="center" justify="center">
          <Button size="small" title="Visualizar" onClick={() => handleEdit(record, true)}>
            <FaEye />
          </Button>
          <Can permission="@lowStock/edit">
            <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
              <FaPencilAlt />
            </Button>
          </Can>
          <Can permission="@lowStock/delete">
            <Popconfirm
              title={i18next.t('messages:confirmDelete')}
              okText={i18next.t('messages:yes')}
              onConfirm={() => handleDelete(record.id)}
              cancelText={i18next.t('messages:no')}
            >
              <Button size="small" title="Excluir">
                <FaRegTrashAlt />
              </Button>
            </Popconfirm>
          </Can>
        </TableActions>
      ),
    },
  ];
};
